import safeUrl from "@/components/features/widgets/safe-url.js";

export default {
	name	: "footer-banner-widget",
	props	: {
		widget: {
			type		: Object,
			required	: true,
		},
	},
	computed: {
		variables() {
			return this.widget && this.widget.variables ? this.widget.variables : {};
		},
		imageDesktop() {
			return this.variables.imageDesktop || "";
		},
		imageMobile() {
			return this.variables.imageMobile || "";
		},
		linkUrl() {
			return safeUrl(this.variables.linkUrl);
		},
		bgColor() {
			return this.variables.bgColor || "#D5F174";
		},
		alt() {
			return this.variables.alt || "";
		},
		closable() {
			return this.variables.closable !== false;
		},
		rootStyle() {
			return {
				backgroundColor : this.bgColor,
			};
		},
	},
	methods: {
		onDismiss() {
			this.$emit("dismiss");
		},
	},
};
